import React from 'react';

export function Checkmark() {
  return (
    <svg width="10" height="8" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.428 7.678a1.03 1.03 0 01-1.495 0L.438 5.16a1.182 1.182 0 01-.42-1.128c.073-.43.371-.778.767-.896.396-.119.82.014 1.094.341l1.72 1.775L8.15.35A1.034 1.034 0 019.184.033c.373.099.668.402.774.796.106.393.007.817-.26 1.112l-5.27 5.736z"
        fill="#FFFFFF"
        fillRule="evenodd"
      />
    </svg>
  );
}
